import { rei } from "@/services/api"

class ComunicacaoService {
  static enviarComunicacoes (params) {
    return rei.post(`comunicacao/intra/enviar`, params).then(res => res.data)
  }
}

export default ComunicacaoService
